function parseExamples(itemData) {
  const contentStartIndexes = {
    all: 0,
    img: 0
  }

  const images = [];
  const redgifs = [];
  const carousels = [];

  itemData.references.forEach(element => {
    if (element.type == 'img' & itemData.img > 0) images.push(element)
    if (element.type == 'redgifs' & itemData.redgifs > 0) redgifs.push(element)
    if (element.type == 'carousel' & itemData.carousel > 0) carousels.push(element)
  })

  contentStartIndexes.redgifs = images.length;
  contentStartIndexes.carousel = images.length + redgifs.length;

  return {exampleArray: [...images, ...redgifs, ...carousels], contentStartIndexes}
}

export default parseExamples;